import { get, cloneDeep } from 'lodash'

/**
 * 获取菜单树第一层级的最叶子菜单进行渲染
 * @param tree 菜单树
 * @returns 
 */
export function getFirstValidTree (tree: any): any {
  if (Array.isArray(tree.Children) && tree.Children.length) {
    return getFirstValidTree(tree.Children[0])
  }
  return tree.Node.ID
}

/**
 * 将菜单树根据排序字段排序
 * @param menus 菜单树
 * @param field 排序字段
 */
export function sortMenusWithField (menus: any[], field: string = 'Node.NUM') {
  menus.sort((a, b) => get(a, field) - get(b, field))
  menus.forEach((menu: any) => {
    const { Children } = menu
    Array.isArray(Children) && Children.length && sortMenusWithField(Children, field)
  })
}

/**
 * 为菜单树附加面包屑等组件需要的 Level 数据
 * @param menus 菜单树
 * @param parentMenu 方法内部变量，可传 undefined
 */
export function generateLevelMenus (menus: any[], parentMenu: any = {}) {
  menus.forEach((menu: any) => {
    const { Node, Children } = menu
    Node.IdLevels = (parentMenu.IdLevels || []).concat(Node.ID)
    Node.NameLevels = (parentMenu.NameLevels || []).concat(Node.NAME)
    Array.isArray(Children) && Children.length && generateLevelMenus(Children, Node)
  })
}

/**
 * 生成一维的菜单树
 * @param menus 菜单树
 * @param flatMenus 目标一维的菜单树
 */
export function generateFlatMenus (menus: any[], flatMenus: any[]) {
  menus.forEach((menu: any) => {
    const { Node, Children } = menu
    flatMenus.push(cloneDeep(Node))
    Array.isArray(Children) && Children.length && generateFlatMenus(Children, flatMenus)
  })
}

/**
 * 获取菜单配置参数
 * @param menu 
 */
export function getMenuFormParams (menu: any) {
  const { MENU_FORM_PARAMS } = menu
  if (!MENU_FORM_PARAMS) return {}

  const params = MENU_FORM_PARAMS.split('|')
  const formParam: any = {}
  params.forEach((param: any) => {
    const keyValues = param.split('=')
    formParam[keyValues[0]] = keyValues[1]
  })
  return formParam
}